import "./GlossaryModal.scss";
import React, { ReactNode, useState } from "react";
import cn from "classnames";
import * as R from "ramda";
import { Modal } from "react-bootstrap";
import { FilterBar } from "../FilterBar/FilterBar";

export interface GlossaryItem {
  term: string;
  definition: ReactNode;
}

interface GlossaryModalProps {
  show: boolean;
  setShow: (boolean) => void;
  title: string;
  initialGlossary: GlossaryItem[];
  modalClassname?: string;
}

export const GlossaryModal: React.FC<GlossaryModalProps> = ({
  show,
  setShow,
  title,
  initialGlossary,
  modalClassname = "",
}) => {
  const [filteredGlossary, setFilteredGlossary] = useState<GlossaryItem[]>(initialGlossary);

  return (
    <Modal
      show={show}
      centered
      onHide={() => {
        setFilteredGlossary(initialGlossary);
        setShow(false);
      }}
      size="lg"
      className={cn("glossaryContainer", { [modalClassname]: modalClassname })}
    >
      <Modal.Header closeButton>
        <div className="modal-title">{title}</div>
      </Modal.Header>
      <Modal.Body>
        <div className="glossaryFilterContainer">
          <FilterBar
            className="glossaryFilter"
            onFilter={
              ((filter: (line: GlossaryItem) => boolean) => {
                setFilteredGlossary(R.filter(filter, initialGlossary));
              }) as any
            }
            hasAdvanced={false}
            options={["term", "definition"]}
            variant="Dropdown"
          />
        </div>
        <div className="glossaryContent">
          {R.sortBy(elem => elem.term, filteredGlossary).map(({ term, definition }) => (
            <div key={term} className="section">
              <div className="term">{term}</div>
              <div className="definition">{definition}</div>
            </div>
          ))}
        </div>
      </Modal.Body>
    </Modal>
  );
};
